export default "public/placeholder.jpg";